import type { Company } from "@/types/company";
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";


export default function useEmpresas() {
  const store = useStore(key);
  let lstEmpresas: Ref<Company[]> = ref([]);

  async function getCompanies(rut: string | null, tipoSolicitud: string | null) {
    try {
      let url = store.state.url + "api/Company/GetCompanies";
      if (rut != null && rut != "") {
        url += "?rut=" + rut;
      }

      await axios
        .get(url, { headers: {} })
        .then((response) => {
          if (response.status == 200) {
            if (tipoSolicitud != null && tipoSolicitud != "" && tipoSolicitud == "Retiro Bodega") {
              //filtrar empresas, solo que aparezcan la empresas que empiezan con 05, 18 y 19
              lstEmpresas.value = (response.data as Company[]).filter((empresa: Company) => {
                return empresa.name.startsWith("05") || empresa.name.startsWith("18") || empresa.name.startsWith("19");
              });
            }
            else {
              lstEmpresas.value = response.data as Company[];
            }



          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return { getCompanies, lstEmpresas };
}